import React from 'react';
import { Box, Typography } from '@mui/material';

export default function SideNote({ message, sx, ...props }) {
  return (
    <Box
      sx={{
        borderTopWidth: 2,
        borderTopStyle: 'solid',
        borderColor: 'secondary.light',
        padding: 1,
        display: { xs: 'none', md: 'block' },
        marginTop: { md: 4, lg: 0 },
        ...sx,
      }}
      {...props}>
      <Typography>{message}</Typography>
    </Box>
  );
}
